import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: 'red',
  },
  title: {
    padding: 8,
    paddingLeft: 0,
    fontWeight: 'bold',
  },
});
